/* jshint esversion: 6 */


import axios from 'axios';
import config from '../../config/app';
import {notification}from 'antd';
// import {message} from 'antd';
import query from 'query-string';
let source = {};
let tokenize = {};

export default function request({dispatch, getState}) {
  return next => action => {
	const {payload, type, ...rest} = action;
	if(!payload) {
		return next(action);
	}
    let CancelToken = axios.CancelToken;
    if (source.token) {
        source.cancel('Canceling Request');
    }
    source = CancelToken.source();
	const REQUEST = type + '_REQUEST';
	const SUCCESS = type + '_SUCCESS';
	const FAIL = type + '_FAILED';

	axios.defaults.headers.common['Accept'] = `application/json`;
	// Use Client Credential for Public API
	if(payload.formData) {
		console.log('formData')
		axios.defaults.headers['Content-Type'] = `multipart/form-data`;
	} else {
		axios.defaults.headers.common['Content-Type'] = `application/x-www-form-urlencoded`;
	}

	if(!payload.public) {
		if (getState().misc.isAuthenticated) {
			tokenize = getState().auth.token;
			// already authenticated
			axios.defaults.headers.common['Authorization'] = `Bearer ${tokenize}`;
		} else {
			// not authenticated
			delete axios.defaults.headers.common['Authorization'];
		}
	} else {
		axios.defaults.headers.common['Authorization'] = `Bearer ${getState().misc.access_token}`;
		if (!getState().misc.isGranted) {
			const oauth_token_payload = {
				grant_type: 'client_credentials',
				client_id: '1',
				client_secret: 'C89FnAib5pzguDiqgptx1liEWQebWndBB7UNCBuh'
			};
			return dispatch({
				type: 'APP_TOKEN',
				payload: {
					method: 'POST',
					url: `/oauth/token`,
					isBaseUrl: true,
					data: oauth_token_payload
				}
			}).then((resp) => {
				console.log(resp);
				axios.defaults.headers.common['Authorization'] = `Bearer ${resp.access_token}`;
				return dispatch(action);
			});
		}
	}

	next({...rest, type:  "LOADING_START"});
	next({...rest, type:  REQUEST});
	return axios({
		async: true,
		crossDomain: true,
		url: payload.isBaseUrl ? config.apiBaseUrl + payload.url : config.apiUrl + payload.url,
		method: payload.method,
		data: !payload.formData ? query.stringify(payload.data) : payload.data
	}).then((res) => {
		const response = res.data;
		next({...rest, type:  "LOADING_FINISH"});
		next({...rest, response, type:  SUCCESS});
		// Is Not Success
		// if(!response.isSuccess) {
		// 	message.warning(response.message);
		// }
		return Promise.resolve(response);
	}).catch((err) => {
		const response = err.response;
		next({...rest, response,type: FAIL});
		next({...rest, type:  "LOADING_FINISH"});
		// handle  by status first
		if(!response) {
			return notification.error({
				message: 'Something Error',
				description: 'Please check your connection or refresh your page. If after you refresh page this error still show, you can contact our customer service.'
			});
		}
		switch (response.status) {
			case 500:
				return notification.error({
					message:  response.statusText,
					description: 'Please check your connection or refresh your page. If after you refresh page this error still show, you can contact our customer service.'
				});		
			case 404:
				return notification.error({
					message: response.statusText,
					description: 'Please check your connection or refresh your page. If after you refresh page this error still show, you can contact our customer service.'
				});		

			default:
				break;
		}

		return Promise.reject(response);
	});



  };
}



// WEBPACK FOOTER //
// ./src/app/middleware/fetch.js